import {IShippingOption} from '../../types/app.types';
import {SelectedCarrierServiceOption} from '@wix/ecom_current-cart/build/es/src/ecom-v1-cart-current-cart.universal';

export type SelectedCarrierServiceOptionWithPrivateFields = SelectedCarrierServiceOption & {
  logistics?: {deliveryTimeSlot: {from: string; to: string}};
};

export class SelectedCarrierServiceOptionModel {
  public code: string;
  public pickupMethod: string;
  public hasTimeSlots: boolean;
  public isPickup: boolean;

  constructor(params: SelectedCarrierServiceOptionModel) {
    this.code = params.code;
    this.pickupMethod = params.pickupMethod;
    this.hasTimeSlots = params.hasTimeSlots;
    this.isPickup = params.isPickup;
  }

  public static fromGQL(option: IShippingOption): SelectedCarrierServiceOptionModel {
    return new SelectedCarrierServiceOptionModel({
      code: option?.id,
      pickupMethod: option?.pickupInfo?.pickupMethod,
      hasTimeSlots: !!option?.deliveryTimeSlot,
      isPickup: !!option?.pickupInfo?.pickupMethod,
    });
  }

  public static fromSDK(option: SelectedCarrierServiceOptionWithPrivateFields): SelectedCarrierServiceOptionModel {
    return new SelectedCarrierServiceOptionModel({
      code: option?.code,
      pickupMethod: option?.logistics?.pickupDetails?.pickupMethod,
      hasTimeSlots: !!option?.logistics?.deliveryTimeSlot,
      isPickup: !!option?.logistics?.pickupDetails?.pickupMethod,
    });
  }
}
